import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPencil, faFloppyDisk} from '@fortawesome/free-solid-svg-icons'

function ChangeBtn({setEditedItem, to_be_edited, edited_item, updateProfile, setInputValue, lawyer_data}) {
  const {user, address_street, address_city, address_post_code, address_street_second, address_post_code_second, address_city_second, rate_per_hour, or_per_case, discount, social_media} = lawyer_data || ''
  const {name: second_city_name} = address_city_second || ''
  const {name: city_name} = address_city || ''
  const {first_name } = user || ''
  const {blog_url, facebook_url, twitter_url} = social_media || ''
  
  return (
  <button id="change-btn" onClick={()=>{
      if (edited_item === to_be_edited) {
        updateProfile()
      } else {
        setEditedItem(to_be_edited)
        if (to_be_edited === 'email') {
          setInputValue({user: {[to_be_edited]: user[to_be_edited]}})
        } else if (to_be_edited === 'address-first') {
          setInputValue({address_street: address_street, address_city: {name: city_name}, address_post_code: address_post_code})
        } else if (to_be_edited === 'address-second') {
          setInputValue({address_street_second: address_street_second, address_city_second: {name: second_city_name}, address_post_code_second: address_post_code_second})
        } else if (to_be_edited === 'first_name') {
          setInputValue({user: {first_name: first_name}})
        } else if (to_be_edited === 'settlement') {
          setInputValue({rate_per_hour: rate_per_hour, or_per_case: or_per_case, discount: discount})
        } else if (to_be_edited === 'blog') {
          setInputValue({social_media: {blog_url: blog_url}})
        } else if (to_be_edited === 'facebook') {
          setInputValue({social_media: {facebook_url: facebook_url}})
          } else if (to_be_edited === 'twitter') {
          setInputValue({social_media: {twitter_url: twitter_url}})
        } else {
          setInputValue({[to_be_edited]: lawyer_data[to_be_edited]})
        }
        
      }
  }}>
  {edited_item !== to_be_edited ?
  <>
      <FontAwesomeIcon icon={faPencil} />
      <span>Zmień</span>
  </>
  :
  <>
      <FontAwesomeIcon icon={faFloppyDisk} />
      <span>Zapisz</span>
  </>
  }
  </button>
  )
}

export default ChangeBtn

